import { render, staticRenderFns } from "./ColumnMappingsEditPanel.vue?vue&type=template&id=6214078a"
import script from "./ColumnMappingsEditPanel.vue?vue&type=script&lang=js"
export * from "./ColumnMappingsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./ColumnMappingsEditPanel.vue?vue&type=style&index=0&id=6214078a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports